import { Node } from "reaflow";
import { TaskShape } from "../shapes/TaskShape";
import CustomPort from "./CustomPort";
import _first from "lodash/first";

const isSafari = false;

export const CustomNode = (nodeProps: any) => {
  const {
    onClick,
    onToggleTaskMenu,
    onDeleteBranch,
    properties: nodeProperties,
    isInconsistent,
  } = nodeProps;
  // @ts-ignore
  const portsHidden = _first(nodeProperties?.ports || [])?.hidden === true;

  return (
    <Node
      {...nodeProps}
      onClick={() => null}
      label={<></>}
      style={{ stroke: "none", fill: "none" }}
      port={
        <CustomPort
          nodeProperties={nodeProperties}
          //
          onClick={() => null}
          onDeleteClick={() => null}
        />
      }
    >
      {(event) => {
        return (
          <g>
            <foreignObject
              onClick={(e) => {
                onClick(e, nodeProperties);
              }}
              style={{
                overflow: "visible",
              }}
              height={event.height}
              width={event.width}
            >
              <div
                style={{
                  width: event.width,
                  height: event.height,
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    position: isSafari ? "relative" : "initial",
                    top: event.y,
                    left: event.x + 25,
                  }}
                >
                  <TaskShape
                    portsVisible={!portsHidden}
                    nodeData={event.node.data}
                    width={event.width}
                    height={event.height}
                    onToggleTaskMenu={onToggleTaskMenu}
                    isInconsistent={isInconsistent}
                    nodeId={event.node.id}
                  />
                </div>
              </div>
            </foreignObject>
          </g>
        );
      }}
    </Node>
  );
};
